export const validationMax = {
  jusrisdictPercent: 100,
  expClaimPercent: 100,
  homeOwnUsePercent: 100,
  percentage: 100
};

export const validationMin = {
  incomeMin: 0,
  costSaleMin: 0,
  expenseMin: 0,
  interestedLoanMin: 0,
  kilometersMin: 0,
  vehicleExpenseMin: 0,
  vehicleAdditionMin: 0,
  vehicleAIIPAmountMin: 0,
  vehicleACBAmountMin: 0,
  vehicleCCAOVAmountMin: 0,
  homeOffExpAmountMin: 0,
  sin: 9,
  uccOpenMin: 0,
  rrspAmoutnMin: 0,
  businessNumber: 9
};

export const regexPatterns = {
  emailPattern: '^(([^<>()\\[\\]\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
  numberPattern: '^[0-9]*$',
  passwordPattern: '^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).{8,32}$',
  phoneNumber: '^((?!(0))[0-9]{10})$'
};
